import { render, staticRenderFns } from "./Postgres95Fields.vue?vue&type=template&id=1a674a09&"
import script from "./Postgres95Fields.vue?vue&type=script&lang=ts&"
export * from "./Postgres95Fields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports